const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const label = (count, unit) => `${count} ${unit}${count === 1 ? '' : 's'} ago`;

/**
 * Relative time label for a chat message: "just now" -> "N minutes ago" ->
 * "N hours ago" -> "N days ago". Pure so it can be tested without fake timers;
 * callers pass the current time in (see Util/custom-hooks/useNow).
 */
export default function timeAgo(date, now = Date.now()) {
    const then = date instanceof Date ? date.getTime() : new Date(date).getTime();
    if (Number.isNaN(then)) {
        return '';
    }
    // Clock skew can put a message slightly in the future - treat it as new.
    const elapsed = Math.max(0, (now instanceof Date ? now.getTime() : now) - then);
    if (elapsed < MINUTE) {
        return 'just now';
    }
    if (elapsed < HOUR) {
        return label(Math.floor(elapsed / MINUTE), 'minute');
    }
    if (elapsed < DAY) {
        return label(Math.floor(elapsed / HOUR), 'hour');
    }
    return label(Math.floor(elapsed / DAY), 'day');
}
